import { faBadgePercent } from '@fortawesome/pro-light-svg-icons/faBadgePercent';
import { ToolbarButton, ToolbarItem } from 'components/UI';
import { FunctionComponent } from 'react';
import Header from './UI/Header';
import Tabs from './SplitPayments/Tabs';
import { TabType } from './Checkout';

export interface CheckoutHeaderProps {
    title: string;
    loading?: boolean;
    tabSelected?: TabType;
    onClose?: () => void;
    onBack?: () => void;
    onAddDiscount?: () => void;
    onSelectTab?: (tabId: TabType) => void;
    className?: string;
}

export const CheckoutHeader: FunctionComponent<CheckoutHeaderProps> = props => {
    return (
        <>
            <Header {...props}>
                {props.onAddDiscount && (
                    <ToolbarButton>
                        <ToolbarItem
                            icon={faBadgePercent}
                            text="Add Discount"
                            onClick={props.onAddDiscount}
                        />
                    </ToolbarButton>
                )}
            </Header>
            {!props.loading && props.onSelectTab && (
                <div style={{ marginTop: 18 }}>
                    <Tabs
                        tabId={props.tabSelected ?? 'details'}
                        onSelect={props.onSelectTab}
                    />
                </div>
            )}
        </>
    );
};

export default CheckoutHeader;
